<template>
  <b-container fluid class='no-paddings'>
    <b-row>
      <b-col sm="3"></b-col>
      <b-col sm="6">
        <v-select label='email' value='id' placeholder='Select user' :on-change='switchUser' class='select-no-caret' v-model='currentUser' :options="users" />
      </b-col>
      <b-col sm="3"></b-col>
    </b-row>
  </b-container>
</template>

<script>
import vSelect from 'vue-select'
import axios from '../../backend'
export default {
  name: 'SwitchUser',
  components: {
    vSelect,
    axios,
  },

  data () {
    return {
      users: [],
      currentUser: ''
    }
  },

  created () {
    this.loadUsers()
  },

  methods: {

    switchUser (user) {
      if (user){
        if (user.id == this.currentUser.id){
          delete axios.defaults.headers['SignAsUserId']
        } else {
          axios.defaults.headers['SignAsUserId'] = user.id;
        }
        this.reloadClients()
        this.loadClientGroups()
        this.$eventBus.$emit('switchUser')
        this.$router.push('/dashboards')
      }
    },

    loadUsers () {
      this.$http.get('/users?switch_user=true')
        .then(function(response){
          this.users = response.data
        }.bind(this))
    },

    reloadClients () {
      this.$http.get('/clients')
        .then(function(response) {
          this.$store.commit('setClients', response.data)
          let currentClient = this.$store.getters.currentClient
          if (!currentClient){
            currentClient = response.data[0]
          }
          this.setCurrentClient(currentClient)
          this.updateLogo(currentClient)
        }.bind(this))
        .catch((e) => console.log(e))
    },

    loadClientGroups () {
      var url = '/client_groups'
      this.$http.get(url)
        .then(function(response){
          var groups = response.data.map( (group) => {
              return {id: group.id, name: group.name + ' (group)', active: group.active}
            }
          )
          this.$store.commit('setClientGroups', groups)
        }.bind(this))
    }

  }

}
</script>
<style scoped>
.dropdown {
  background-color: #fff;
}
</style>
